import { render, staticRenderFns } from "./SearchResultBody.vue?vue&type=template&id=75a1938c&scoped=true&"
import script from "./SearchResultBody.vue?vue&type=script&lang=ts&"
export * from "./SearchResultBody.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultBody.vue?vue&type=style&index=0&id=75a1938c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a1938c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VList,VRow,VSkeletonLoader})
